import axios from "axios";

import { baseUrl } from "./baseUrl";

const api = axios.create({
    baseURL: `${baseUrl}/admin/dashboard`,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});

export const getDashboardData = async () => {
    try {
        const res = await api.get("/dashboard-data");
        return res.data.data;
    } catch (error) {
        console.error("Error fetching dashboard data:", error);
        throw error;
    }
};

export const getSnapshotData = async () => {
    try {
        const res = await api.get("/snapshot");
        return res.data.data;
    } catch (error) {
        console.error("Error fetching snapshot data:", error);
        throw error;
    }
}

export const getImpactMatrixData = async () => {
    try {
        const res = await api.get("/impact-matrix");
        return res.data.data;
    } catch (error) {
        console.log("Error fetching impact matrix data:", error);
        throw error;
    }
}

export const getSubmissionStatsData = async () => {
    try {
        const res = await api.get("/user-participation");
        return res.data.data;
    } catch (error) {
        console.log("Error fetching submission stats data:", error);
        throw error;
    }
}

export const getReferralsData = async () => {
    try {
        const res = await api.get("/referrals");
        return res.data.data;
    } catch (error) {
        console.log("Error fetching submission stats data:", error);
        throw error;
    }
}

export const getLeaderBoard = async () => {
    try {
        const res = await api.get("/leaderboard");
        return res.data.data;
    } catch (error) {
        console.log("Error fetching leaderboard data:", error);
        throw error;
    }
}

export const getToDo = async () => {
    try {
        const res = await api.get("/to-do");
        return res.data.data;
    } catch (error) {
        console.log("Error fetching todo data:", error);
        throw error;
    }
}

export const getExpiringCampaigns = async () => {
    try {
        const res = await api.get("/expiring-campaigns");
        return res.data.data;
    } catch (error) {
        console.log("Error fetching todo data:", error);
        throw error;
    }
}

export const getExpiringEvents = async () => {
    try {
        const res = await api.get("/expiring-events");
        return res.data.data;
    } catch (error) {
        console.log("Error fetching todo data:", error);
        throw error;
    }
}

export const getMissionControl = async () => {
    try {
        const res = await api.get("/mission-control");
        return res.data.data;
    } catch (error) {
        console.log("Error fetching mission control data:", error);
        throw error;
    }
}